const strings = {
  textModal: {
    addModalTitle: 'Adicionar Associação',
  },
}

export default strings
